





import { defineComponent, onMounted } from "@vue/composition-api";

export default defineComponent({
  name: "NotConfiguredPayout",
  setup(_, { emit }) {
    onMounted(() => {
      emit("validation", true);
    });
  },
});
